import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';
import VideoController from './controllers/video-controller';
import SelectController from "./controllers/select-controller";
import ClickTrackerController from "./controllers/click-tracker-controller";

require('./navigation');
require('./lightbox');
require('./misc');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('cookie-bar', CookieBarController);
application.register('modal', ModalController);
application.register('tab', TabController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('video', VideoController);
application.register('select', SelectController);
application.register('click-tracker', ClickTrackerController);

const userDocument = document.querySelector('#user-file');
if (typeof(userDocument) != 'undefined' && userDocument != null)
{
    const interactive = document.querySelector(".upload-document-interact");
    const uploadMessage = document.querySelector(".upload-message");
    const interactiveSpan = interactive.querySelector('span').innerHTML;

    interactive.addEventListener("click", function(e) {
        e.preventDefault();
        userDocument.click();
    }, false);

    document.querySelector(".remove-document").addEventListener("click", function(e) {
        e.preventDefault();
        userDocument.value = "";
        interactive.querySelector('span').innerHTML = interactiveSpan;
    }, false);

    userDocument.addEventListener("change", function(e)
    {
        if (userDocument.files[0]) {
            if (userDocument.files[0].size > 2000000) {
                userDocument.value = "";
                interactive.querySelector('span').innerHTML = interactiveSpan;
                uploadMessage.innerHTML = theme.file_to_large;
            } else {
                interactive.querySelector('span').innerHTML = userDocument.files[0].name;
                uploadMessage.innerHTML = "";
            }
        }
    }, false);
}

const userPhoto = document.querySelector('#user-photo');
if (typeof(userPhoto) != 'undefined' && userPhoto != null)
{
    const interactive = document.querySelector(".upload-photo-interact");
    const uploadMessage = document.querySelector(".upload-message");
    const uploadPhoto = document.querySelector("#user-photo-uploaded");

    interactive.addEventListener("click", function(e) {
        e.preventDefault();
        userPhoto.click();
    }, false);

    document.querySelector(".add-photo").addEventListener("click", function(e) {
        e.preventDefault();
        userPhoto.click();
    }, false);

    document.querySelector(".remove-photo").addEventListener("click", function(e) {
        e.preventDefault();
        userPhoto.value = "";
        interactive.classList.add("-empty");
        interactive.innerHTML = '';

        uploadPhoto.value = "";

    }, false);

    userPhoto.addEventListener("change", function(e)
    {
        if (userPhoto.files[0]) {
            if (userPhoto.files[0].size > 2000000) {
                userPhoto.value = "";
                interactive.classList.add("-empty");
                interactive.innerHTML = '';
                uploadMessage.innerHTML = theme.file_to_large;
            } else {
                const tempUrl = URL.createObjectURL(userPhoto.files[0]);
                interactive.classList.remove("-empty");
                interactive.innerHTML = '<img src="'+ tempUrl +'" alt="" />';
                uploadMessage.innerHTML = "";
            }
        }
    }, false);

    updateUploadedPhoto();
    function updateUploadedPhoto()
    {
        const image = uploadPhoto.value;
        if (image) {
            interactive.classList.remove("-empty");
            interactive.innerHTML = '<img src="'+ image +'" alt=""/>';
        }
    }
}